/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CampaignDetailsTabTypes, Networks } from 'AdsUI/lib/Constants';
import ReportingCampaignRecord from 'AdsUI/records/reporting/ReportingCampaignRecord';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { hasWriteScope } from 'AdsUI/selectors/AuthSelectors';

class CampaignDetailsTabsContainer extends PureComponent {
  getTabs() {
    const {
      network,
      history,
      match: {
        params: {
          accountId,
          campaignId
        }
      }
    } = this.props;
    const basePath = `accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}`;
    /* Manage tab (the standard details page) */

    const tabs = [/*#__PURE__*/_jsx(UITab, {
      tabId: CampaignDetailsTabTypes.MANAGE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "manage"
      }),
      onClick: () => history.push(`/${basePath}`)
    }, CampaignDetailsTabTypes.MANAGE)]; // Support old Ads Free FB campaign breakdowns chart

    if (network === Networks.FACEBOOK) {
      tabs.push( /*#__PURE__*/_jsx(UITab, {
        tabId: CampaignDetailsTabTypes.ANALYZE,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "analyze"
        }),
        onClick: () => history.push(`/${basePath}/analyze`)
      }, CampaignDetailsTabTypes.ANALYZE));
    }

    return tabs;
  }

  render() {
    const {
      activeTab
    } = this.props;
    const tabs = this.getTabs();

    if (tabs.length <= 1) {
      // If the only tab available is the "manage" tab, we don't need to show the tabs here
      return null;
    } else {
      return /*#__PURE__*/_jsx(UITabs, {
        selected: activeTab,
        children: tabs
      });
    }
  }

}

CampaignDetailsTabsContainer.propTypes = {
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  campaignEntity: PropTypes.oneOfType([PropTypes.instanceOf(ReportingCampaignRecord)]),
  activeTab: PropTypes.oneOf(Object.keys(CampaignDetailsTabTypes)).isRequired
};

const mapStateToProps = state => ({
  hasWrite: hasWriteScope(state)
});

export default withRouter(connect(mapStateToProps)(CampaignDetailsTabsContainer));